import React from 'react';

const LungSolution = () => {
    return (
        <div className="flex flex-col items-center font-sans">
            <div className="w-full max-w-[250px] h-[15px] bg-[#1a2b5f] my-[100px] mb-[22px]"></div>
            <div className="w-full max-w-5xl mx-auto px-[16px]">
                <h1 className="text-center text-[#1a2b5f] text-[42px] font-bold">
                    The 21-Day Lung Solution - FREE Lifetime Access
                </h1>
                {/* <div className="w-full relative"> */}
                    <img
                        src="https://breatheagain.io/order-confirmation/assets/the-21-day-lung-solution.png"
                        alt="21-Day Lung Solution Program on multiple devices"
                        // className="w-full h-full object-contain"
                        // draggable="false"
                    />
                {/* </div> */}
                <div className="text-[#4A4A4A] ">
                    <p className="text-[22px] leading-[35px] font-normal pb-[10px] mt-[20px]">
                        You get <span className="font-bold">free access</span> to the 21-Day Lung Solution to help you strengthen your lungs and breathe freely again. Here you’ll find tons of resources, guides, and recipes to make it easy to live a happy and healthy lifestyle.
                    </p>
                    <p className="text-[22px] leading-[35px] font-normal pb-[10px]">
                        <span className="font-bold">Your login details</span> have been sent to the email address you used during checkout. If you can't find it in your Inbox, please check your spam, junk, and promotions folders. If this is the case, please add our email address to your contact list to ensure it doesn't end up in the spam or junk folder again.
                    </p>
                    <p className="text-[22px] leading-[35px] font-normal">
                        You can also contact our support desk at the bottom of this page if you have any questions or concerns.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LungSolution;
